
<div class="container" [ngClass]="{'general-disabled': sandyPreImportData?.isMigrationActive}">
  <md-spinner-block *ngIf="loading"></md-spinner-block>
  <div class="row" *ngIf="!loading">
    <div class="col">
      <h3>Import OSS/Sandy Report</h3>
    </div>
  </div>
  <div class="row" *ngIf="!loading &amp;&amp; sandyPreImportData.canImport">
    <div class="col">
      <div class="alert alert-info"><span class="d-block" *ngIf="sandyPreImportData.assets &gt; 0">{{ sandyPreImportData.assets }} asset(s) are missing serial numbers.</span><span class="d-block" *ngIf="sandyPreImportData.bundledAccessories &gt; 0">{{ sandyPreImportData.bundledAccessories }} bundled accessories are missing serial numbers.</span><span class="d-block" *ngIf="sandyPreImportData.standaloneAccessories &gt; 0">{{ sandyPreImportData.standaloneAccessories }} standalone accessories are missing serial numbers.</span></div>
    </div>
  </div>
  <div class="row" *ngIf="!loading &amp;&amp; !sandyPreImportData.canImport">
    <div class="col">
      <div class="alert alert-success">All items have serial numbers.</div>
    </div>
  </div>
  <div class="row" *ngIf="!loading">
    <div class="col">
      <div class="btn-group float-right">
        <button class="btn" *ngIf="sandyPreImportData.canImport" [ngClass]="{'btn-outline-primary': !showMatcher, 'btn-outline-dark': showMatcher}" type="button" [uploadFileTo]="'/api/oss-sandy/import'" [params]="importParams" [responseProcessor]="sandyImportResponseProcessor" (closed)="fileUploaded($event)" [disabled]="!entityId">Upload OSS/SANDY Report</button>
        <button class="btn" *ngIf="sandyPreImportData.canImport" [ngClass]="{'btn-primary': !showMatcher, 'btn-outline-dark': showMatcher}" type="button" (click)="fetch()" [disabled]="!entityId">Get OSS/Sandy Data</button>
        <button class="btn btn-outline-primary" *ngIf="showMatcher" type="button" (click)="autoAssignAll()">Auto-assign serial numbers</button>
        <button class="btn btn-primary" *ngIf="showMatcher" type="button" (click)="save()">Save All</button>
      </div>
    </div>
  </div>
  <div class="row mt-4" *ngIf="showMatcher &amp;&amp; !loading">
    <div class="col">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filteredAssets.length" (onChange)="onListControlsChange($event)"></list-controls>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Asset</th>
            <th>Map ID</th>
            <th>Order Info</th>
            <th>Serial Number</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let asset of displayedAssets; let i = index">
            <td class="table-cell-compact"><b>[{{ asset.readableType }}]</b> {{ asset.productDescription }} <b>({{ asset.productNumber }})</b><br>Device Key: {{ asset.deviceKey }}<br>Site: {{ asset.site }}<br><span *ngIf="asset.building">Building: {{ asset.building }}</span><span *ngIf="asset.building &amp;&amp; asset.floor"><br></span><span *ngIf="asset.floor">Floor: {{ asset.floor }}</span>
            </td>
            <td class="vertical-align-middle">{{ asset.mapId }}</td>
            <td class="vertical-align-middle">Order Number: <b>{{ asset.orderNumber }}</b><br>Order Date: {{ asset.orderDate }}</td>
            <td class="vertical-align-middle">{{ asset.serialNumber }}</td>
            <td class="vertical-align-middle">
              <button class="btn btn-outline-primary btn-sm float-right" type="button" (click)="changeSerialNumber(asset)">Change</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>